import { BiAddToQueue } from "react-icons/bi";
import { v4 as uuidv4 } from "uuid";
import React from "react";
import { contvertHTMLToPlain, isTrivvyProduct } from "../../utils/constants";
import moment from "moment";

export const SURVEY_LIST = [
  {
    name: "Survey1",
    questions: 5,
    responses: 40,
    completion: 50,
    updatedAt: new Date(),
  },
  {
    name: "Survey2",
    questions: 5,
    responses: 40,
    completion: 50,
    updatedAt: new Date(),
  },
];

export const TRIVVY_ADMIN_EMAIL_TYPES = [
  {
    label: "Don't notify me.",
    value: 1,
  },
  {
    label: "Email me each time I get a response.",
    value: 2,
  },
  {
    label: "Email me at the end of the trivvy.",
    value: 3,
  },
];

export const TRIVVY_REMINDER_NOTIFICATION_FREQUENCY = [
  {
    label: "Don't Remind",
    value: 1,
  },

  {
    label: "Remind Daily",
    value: 2,
  },
  {
    label: "Remind Every Other Day",
    value: 3,
  },
  {
    label: "Remind Weekly",
    value: 4,
  },
];

export const WEEK_DAYS = [
  {
    label: "Monday",
    value: 1,
  },
  {
    label: "Tuesday",
    value: 2,
  },
  {
    label: "Wednesday",
    value: 3,
  },
  {
    label: "Thursday",
    value: 4,
  },
  {
    label: "Friday",
    value: 5,
  },
  {
    label: "Saturday",
    value: 6,
  },
  {
    label: "Sunday",
    value: 7,
  },
];

export const REWARD_ADMIN_EMAIL_TYPES = [
  {
    label: "Don't notify me.",
    value: 1,
  },
  {
    label: "Email me at the end of the reward.",
    value: 2,
  },
];

export const THEME_SETTING = {
  // rgb(253 236 232)
  quizBackgroundColor: "rgb(253, 236, 232)",
  // "rgb(215, 250, 239)"
  quizTextColor: "rgb(255, 98, 51)",
  fontFamilyName: "",
  fontStyle: "",
};

const computeQuestionId = (name, orgId) => {
  // let orgName = org.replace(/ /g,'').toLowerCase().replace(/\s+/g, '')

  const objId = uuidv4();

  let result =
    objId +
    "?" +
    [...name].reduce((acc, currVal) => acc.concat(currVal.charCodeAt())) +
    "?" +
    orgId;

  return result;
};

export const hashText = (name) => {
  return [...name].reduce((acc, currVal) => acc.concat(currVal.charCodeAt()));
};

export const getNewQuestionEmptyObject = (
  trivia,
  orgId,
  order_number,
  type
) => {
  if (type === "MCQ") {
    return {
      isCustomInput: false,
      question_id: computeQuestionId(trivia.name, orgId),
      question_text: "",
      order: order_number,
      options: [
        {
          text: `Option ${1}`,
          option_order: 1,
          option_id: `${1}?${hashText(`Option ${1}`)}?${trivia._id}?${orgId}`,
        },
      ],
      correct_options: [],
      //type int - seconds
      time: 10,
      media_url: [],
      is_ai_generated: false,
      created_by: trivia.userId,
      theme_settings: {
        // quizBackgroundColor: "rgb(215, 250, 239)",
        quizBackgroundColor: "rgb(253, 236, 232)",
        // ff6233
        // rgb(255 98 51)
        quizTextColor: "rgb(255, 98, 51)",
        // "rgb(4, 29, 27)
      },
      question_type: "MCQ",
      linearNumericConfigs: { min: 1, max: 10 },
    };
  } else {
    return {
      question_type: "TEXT",
      question_id: computeQuestionId(trivia.name, orgId),
      question_text: "",
      order: order_number,
      custom_question_input_type: "TEXT_INPUT",
      options: [],
      correct_options: [],
      time: 10,
      media_url: [],
      is_ai_generated: false,
      created_by: trivia.userId,
      theme_settings: {
        // quizBackgroundColor: "rgb(215, 250, 239)",
        quizBackgroundColor: "rgb(253, 236, 232)",
        quizTextColor: "rgb(255, 98, 51)",
        // "rgb(4, 29, 27)
      },
    };
  }
};

export const getTriviaFileName = (trivia) => {
  if (trivia) {
    trivia.uploadUrl = trivia.uploadUrl
      ? trivia.uploadUrl.replace("/?", "?").replace(/\?.*/, "")
      : null;

    if (
      trivia.librarySourceType != null &&
      trivia.librarySourceType != undefined &&
      trivia.librarySourceType >= 0
    ) {
      if (trivia.libName) {
        return trivia.libName;
      } else {
        if (
          trivia.uploadFileName &&
          trivia.uploadFileName.length > 0 &&
          trivia.uploadFileName != "undefined" &&
          trivia.uploadFileName != null &&
          trivia.uploadFileName != "null"
        ) {
          const fileName = trivia._id
            ? trivia.uploadFileName
            : decodeURIComponent(trivia.uploadFileName)
                .replace(/[0-9]/g, "")
                .replace("trivia/document/", "")
                .replaceAll("-", "")
                .replaceAll("+", " ");
          if (!trivia.clip && fileName && fileName.length > 50) {
            let f1 = fileName.slice(0, 50);
            return trivia.showFull ? fileName : `${f1}...`;
          } else {
            return fileName;
          }
        } else {
          if (trivia.librarySourceType == 0) {
            if (trivia.webUrl) {
              const domain = trivia.webUrl.match(
                /https?:\/\/(?:www\.)?([^\/]+)/
              )[1];
              return domain;
            } else {
              return "Webpage";
            }
          } else if (trivia.librarySourceType == 2) {
            return "Custom Text";
          } else if (
            trivia &&
            trivia.uploadUrl &&
            trivia.uploadUrl.length > 0 &&
            trivia.uploadUrl != "undefined" &&
            trivia.uploadUrl != null &&
            trivia.uploadUrl != "null"
          ) {
            let fileName = "";
            let fileNamePartsArr = trivia.uploadUrl.split("/");
            let fileNamePartsLast = decodeURIComponent(
              fileNamePartsArr[fileNamePartsArr.length - 1]
            );
            const toolRegex = /^\d+\?\d+\?.+/;
            if (toolRegex.test(fileNamePartsLast)) {
              const regex = /[^?]+$/; // Match everything after the last question mark (?)

              const match = fileNamePartsLast.match(regex);

              if (match) {
                const extractedPart = match[0];
                fileNamePartsLast = extractedPart;
              }
            }
            fileName = decodeURIComponent(fileNamePartsLast);
            if (!trivia.clip && fileName && fileName.length > 50) {
              let f1 = fileName.slice(0, 50);
              return trivia.showFull ? fileName : `${f1}...`;
            } else {
              return fileName;
            }
          } else {
            return null;
          }
        }
      }
    }
  } else {
    return null;
  }
};

export const TRIVIA_SHARE_PRIVACY_OPTIONS = [
  { label: "Anyone with this link", value: "PUBLIC" },
  { label: "Users on platform", value: "ENTERPRISE" },
  // { label: "Users on platform", value: "CUSTOM" },
];
export const TRIVIA_USER_IDENTIFICATION_OPTIONS = [
  { label: "Email", value: "EMAIL", field: 'email'},
  { label: "Employee ID", value: "EMPLOYEE_ID", field:'employeeId'},
  { label: "Mobile Number", value: "MOBILE_NUMBER", field: 'mobileNumber'},
  { label: "First and Last Name", value: "FIRST_LAST_NAME" },
  // { label: "Anonymous", value: "ANONYMOUS" },
];
export const TRIVIA_LIB_PRIVACY_OPTIONS = [
  { label: "Enterprise", value: "ENTERPRISE" },
  { label: "Custom", value: "CUSTOM" },
  { label: "Private", value: "PRIVATE" },
];

export const PUBLISH_SAVE_ERROR = "You cant edit Trivvy after publish";

export const noScoreTrivvy = (trivia) => {
  if (
    trivia &&
    [
      "CAREER_ADVANCEMENT",
      "BENEFITS",
      "CUSTOMER_SATISFACTION",
      "WORKPLACE_RELATIONSHIP",
    ].includes(trivia.templateType)
  ) {
    return true;
  } else {
    return false;
  }
};
export const trivvyFromCustomTemplates = (trivia) => {
  if (
    trivia &&
    [
      "CAREER_ADVANCEMENT",
      "BENEFITS",
      "CUSTOMER_SATISFACTION",
      "WORKPLACE_RELATIONSHIP",
    ].includes(trivia.templateType)
  ) {
    return true;
  } else {
    return false;
  }
};

export const publishDisabled = (trivia) => {
  let isDisabled = true;

  if (
    [
      "CAREER_ADVANCEMENT",
      "BENEFITS",
      "CUSTOMER_SATISFACTION",
      "WORKPLACE_RELATIONSHIP",
    ].includes(trivia.templateType)
  ) {
    return false;
  }

  if (trivia && trivia.questions) {
    let qCount = 0;
    for (const question of trivia.questions) {
      if (
        question.question_type == "MCQ" &&
        question.correct_options &&
        question.correct_options[0] &&
        question.correct_options[0].option_id
      ) {
        qCount += 1;
      }
    }

    const validQuestions = trivia.questions.filter(
      (x) => x.question_type == "MCQ"
    );

    console.log({qCount,validQuestions});

    if (qCount == validQuestions.length) {
      isDisabled = false;
    } else {
      isDisabled = true;
    }

    return isDisabled
  }

  return false;
};

export const getObjectForShareTrivvyResult = (data) => {
  return {
    triviaName: data.triviaName,
    createdBy: data.quizAdmin ? data.quizAdmin.firstName : "",
    totalQuestions: data.quizQuestions.length,
    totalCorrect: data.totalCorrect,
    totalWrong: data.totalWrong,
    correctPercent: data.correctPercent,
    timeTaken: data.totalTime,
  };
};
export const getObjectForShareMessageResult = (data) => {
  return {
    triviaName: data.triviaName,
    createdBy: data.quizAdmin ? data.quizAdmin.firstName : "",
    
  };
};

export const WEB_GENERATE_ERROR_MESSAGE =
  "Your content is not well-suited to creating a high quality trivvy. Consider pasting text content or uploading it as a pdf.";

export const CUSTOM_QUESTION_INPUT_TYPES = [
  { label: "Multiple Choice", value: "MCQ", icon: <BiAddToQueue /> },
  { label: "Text Input", value: "TEXT" },
  { label: "Linear Scale", value: "LINEAR_NUMERIC" },
];

export const getInputTypeLabel = (type) => {
  const CUSTOM_QUESTION_INPUT_TYPES_MAP = {
    MCQ: "Multiple Choice",
    TEXT: "Text Input",
    LINEAR_NUMERIC: "Linear Scale",
  };

  return CUSTOM_QUESTION_INPUT_TYPES_MAP[type]
    ? CUSTOM_QUESTION_INPUT_TYPES_MAP[type]
    : "";
};

export const MIN_OPTIONS_ARRAY = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
];

export const MAX_OPTIONS_ARRAY = [
  { label: 1, value: 1 },
  { label: 2, value: 2 },
  { label: 3, value: 3 },
  { label: 4, value: 4 },
  { label: 5, value: 5 },
  { label: 6, value: 6 },
  { label: 7, value: 7 },
  { label: 8, value: 8 },
  { label: 9, value: 9 },
  { label: 10, value: 10 },
];

// export const getTrivvyPlanDetailsPlanWise = (plan, array) => {
//   if (plan == "003") {
//     return {
//       name: array[2].name,
//       price: "$" + array[2].costPerMonth,
//       responses: array[2].responses,
//       description: array[2].description,
//       cost: array[2].costPerMonth,
//       seats: array[2].userSeats,
//       performanceMetrics: array[2].metrics,
//       rewardFeature: array[2].rewardFeature ? "Yes" : "No",
//       reminderFeature: array[2].reminderFeature,
//       metricsByTrivvy: array[2].metricsByTrivvy,
//       metricsByQuestion: array[2].metricsByQuestion,
//       metricsByUsers: array[2].metricsByUsers,
//       smsLimit: array[2].smsLimit,
//     };
//   } else if (plan == "002") {
//     return {
//       name: array[1].name,
//       price: "$" + array[1].costPerMonth,
//       responses: array[1].responses,
//       description: array[1].description,
//       cost: array[1].costPerMonth,
//       seats: array[1].userSeats,
//       performanceMetrics: array[1].metrics,
//       rewardFeature: array[1].rewardFeature ? "Yes" : "No",
//       reminderFeature: array[1].reminderFeature,
//       metricsByTrivvy: array[1].metricsByTrivvy,
//       metricsByQuestion: array[1].metricsByQuestion,
//       metricsByUsers: array[1].metricsByUsers,
//       smsLimit: array[1].smsLimit,
//     };
//   } else if (plan == "001") {
//     return {
//       name: array[0].name,
//       price: "$" + array[0].costPerMonth,
//       isFree: array[0].isFree,
//       responses: array[0].responses,
//       description: array[0].description,
//       seats: array[0].userSeats,
//       performanceMetrics: array[0].metrics,
//       rewardFeature: array[0].rewardFeature ? "Yes" : "No",
//       reminderFeature: array[0].reminderFeature,
//       metricsByTrivvy: array[0].metricsByTrivvy,
//       metricsByQuestion: array[0].metricsByQuestion,
//       metricsByUsers: array[0].metricsByUsers,
//       smsLimit: array[0].smsLimit,
//     };
//   } else if (plan == "004") {
//     return {
//       name: array[3].name,
//       price: "$" + array[3].costPerMonth,
//       responses: array[3].responses,
//       description: array[3].description,
//       cost: array[3].costPerMonth,
//       seats: array[3].userSeats,
//       performanceMetrics: array[3].metrics,
//       rewardFeature: array[3].rewardFeature ? "Yes" : "No",
//       reminderFeature: array[3].reminderFeature,
//       unlimitedUserSeats: array[3].unlimitedUserSeats,
//       metricsByTrivvy: array[3].metricsByTrivvy,
//       metricsByQuestion: array[3].metricsByQuestion,
//       metricsByUsers: array[3].metricsByUsers,
//       smsLimit: array[3].smsLimit,
//     };
//   } else {
//     return {};
//   }
// };


export const getTrivvyPlanDetailsPlanWise = (planCode, plansArray) => {
  if (!plansArray || !plansArray.length) return null;

  const plan = plansArray.find((p) => p.code === planCode);
  if (!plan) return {};

  return {
    name: plan.name,
    price: plan.costPerMonth ? `$${plan.costPerMonth}` : undefined,
    cost: plan.costPerMonth,
    responses: plan.responses,
    description: plan.description,
    seats: plan.userSeats,
    performanceMetrics: plan.metrics,
    rewardFeature: plan.rewardFeature ? "Yes" : "No",
    reminderFeature: plan.reminderFeature,
    metricsByTrivvy: plan.metricsByTrivvy,
    metricsByQuestion: plan.metricsByQuestion,
    metricsByUsers: plan.metricsByUsers,
    smsLimit: plan.smsLimit,
    isFree: plan.isFree || false,
    unlimitedUserSeats: plan.unlimitedUserSeats || false,
  };
};



//--------LIVE----------------
// export const RECURRING_PLAN_PRICE_DATA = [
//   {
//     plan: "002",
//     priceId: "price_1OPIL4C7Hc2xQjayDTdFF8p6",
//   },
//   {
//     plan: "003",
//     priceId: "price_1OPIKcC7Hc2xQjayY2gFsMBv",
//   },
// ];

// export const RESPONSE_PURCHASE_DATA = [
//   {
//     responses: 100,
//     quantity: 0,
//     price: 10,
//     priceId: "price_1OMmGAC7Hc2xQjayUXOV2hhZ",
//   },
//   {
//     responses: 500,
//     price: 50,
//     quantity: 0,
//     priceId: "price_1OMmGTC7Hc2xQjay4DJJA2Qx",
//   },
//   {
//     responses: 1000,
//     price: 100,
//     quantity: 0,
//     priceId: "price_1OMmGlC7Hc2xQjaydbEPPmJI",
//   },
// ];

// -----------TEST------------
export const RECURRING_PLAN_PRICE_DATA = window.location.href.indexOf("trivvy.ouroffice.io") >= 0
  ? [
      {
        plan: "002",
        priceId: "price_1OPIL4C7Hc2xQjayDTdFF8p6",
      },
      {
        plan: "003",
        priceId: "price_1OPIKcC7Hc2xQjayY2gFsMBv",
      },
    ]
  : [
      {
        plan: "002",
        priceId: "price_1OPI8bC7Hc2xQjaySo60y0tn",
      },
      {
        plan: "003",
        priceId: "price_1OPI99C7Hc2xQjaybxn7FM6h",
      },
    ];

export const SMS_TEXTS_PURCHASE_DATA = window.location.href.indexOf("trivvy.ouroffice.io") >= 0
  ? [
      {
        smsTexts: 100,
        quantity: 0,
        price: 25,
        priceId: "price_1PImvAC7Hc2xQjayejfg8U0y",
      },
      {
        smsTexts: 500,
        price: 100,
        quantity: 0,
        priceId: "price_1PImv1C7Hc2xQjay49ibC48T",
      },
      {
        smsTexts: 1000,
        price: 150,
        quantity: 0,
        priceId: "price_1PImumC7Hc2xQjaykXpkdAHD",
      },
    ]
  : [
      {
        smsTexts: 100,
        quantity: 0,
        price: 25,
        priceId: "price_1PIms8C7Hc2xQjaySt0gsAO7",
      },
      {
        smsTexts: 500,
        price: 100,
        quantity: 0,
        priceId: "price_1PImuSC7Hc2xQjayfnPHNUjM",
      },
      {
        smsTexts: 1000,
        price: 150,
        quantity: 0,
        priceId: "price_1PImthC7Hc2xQjayPQVB557y",
      },
    ];

export const RESPONSE_PURCHASE_DATA = window.location.href.indexOf("trivvy.ouroffice.io") >= 0
  ? [
      {
        responses: 100,
        quantity: 0,
        price: 10,
        priceId: "price_1ObyoaC7Hc2xQjayMhNnjiaU",
      },
      {
        responses: 500,
        price: 50,
        quantity: 0,
        priceId: "price_1ObynBC7Hc2xQjay127Nc7MG",
      },
      {
        responses: 1000,
        price: 100,
        quantity: 0,
        priceId: "price_1OMmGlC7Hc2xQjaydbEPPmJI",
      },
    ]
  : [
      {
        responses: 100,
        quantity: 0,
        price: 10,
        priceId: "price_1OMtAIC7Hc2xQjayZe8Sunr0",
      },
      {
        responses: 500,
        price: 50,
        quantity: 0,
        priceId: "price_1OMtAYC7Hc2xQjaycEJtU2p1",
      },
      {
        responses: 1000,
        price: 100,
        quantity: 0,
        priceId: "price_1OMtAuC7Hc2xQjay7TzZwS4v",
      },
    ];

export const NUMBER_OF_ATTEMPTS_ALLOWED = [
  {
    label: "None",
    value: "NO",
  },
  {
    label: "As many as needed",
    value: "MANY",
  },
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },

  {
    label: "6",
    value: 6,
  },
  {
    label: "7",
    value: 7,
  },
  {
    label: "8",
    value: 8,
  },
  {
    label: "9",
    value: 9,
  },

  {
    label: "10",
    value: 10,
  },
];

export const getAttemptNumberFilterOptions = (maxAttempts) => {
  const attempts_array = [
    {
      label: "All Attempts",
      value: 0,
    },
    {
      label: "1",
      value: 1,
    },
    {
      label: "2",
      value: 2,
    },
    {
      label: "3",
      value: 3,
    },
    {
      label: "4",
      value: 4,
    },
    {
      label: "5",
      value: 5,
    },

    {
      label: "6",
      value: 6,
    },
    {
      label: "7",
      value: 7,
    },
    {
      label: "8",
      value: 8,
    },
    {
      label: "9",
      value: 9,
    },

    {
      label: "10",
      value: 10,
    },
  ];

  const filtered = attempts_array.slice(0, maxAttempts + 1);

  return filtered;
};
export const ATTEMPT_NO_FILTER = [
  {
    label: "All Attempts",
    value: 0,
  },
  {
    label: "1",
    value: 1,
  },
  {
    label: "2",
    value: 2,
  },
  {
    label: "3",
    value: 3,
  },
  {
    label: "4",
    value: 4,
  },
  {
    label: "5",
    value: 5,
  },

  {
    label: "6",
    value: 6,
  },
  {
    label: "7",
    value: 7,
  },
  {
    label: "8",
    value: 8,
  },
  {
    label: "9",
    value: 9,
  },

  {
    label: "10",
    value: 10,
  },
];

export const getThemeSettingsForPage = (trivia, currentQuestion) => {
  if (currentQuestion === "WELCOME") {
    return trivia.themeSettings;
  } else if (currentQuestion === "RATING") {
    return trivia.themeSettingsRatingPage;
  } else if (currentQuestion.question_id) {
    return currentQuestion.theme_settings;
  } else if (currentQuestion === "ENDING") {
    return (
      trivia.themeSettingsEndingPage || {
        quizBackgroundColor: null,
        quizTextColor: "rgb(255,255,255)",
      }
    );
  } else {
    return THEME_SETTING;
  }
};

export const isThemeSettingsAppliedToAllPages = (trivia) => {
  if (!trivia || !Array.isArray(trivia.questions)) {
    console.error("Invalid trivia object");
    return false;
  }

  const expectedMatchCount = 3 + trivia.questions.length;
  const matchObject = trivia.themeSettings || THEME_SETTING;
  let actualMatchCount = 1;

  const checkThemeSettingsMatch = (settings) => {
    return (
      settings &&
      settings.quizBackgroundColor === matchObject.quizBackgroundColor &&
      settings.quizTextColor === matchObject.quizTextColor &&
      settings.fontFamilyName === matchObject.fontFamilyName &&
      settings.fontStyle === matchObject.fontStyle
    );
  };

  for (const question of trivia.questions) {
    if (checkThemeSettingsMatch(question.theme_settings)) {
      actualMatchCount += 1;
    }
  }

  if (checkThemeSettingsMatch(trivia.themeSettingsRatingPage)) {
    actualMatchCount += 1;
  }

  if (checkThemeSettingsMatch(trivia.themeSettingsEndingPage)) {
    actualMatchCount += 1;
  }
  return actualMatchCount === expectedMatchCount;
};

export const isNewPlanUpgradable = (currentPlan, newPlan, org) => {
  const currentPlanInt = parseInt(currentPlan.replace("0", ""));
  const newPlanInt = parseInt(newPlan.replace("0", ""));

  if (org.nextPaymentDate) {
    if (moment(org.nextPaymentDate).isSameOrBefore(moment().endOf("day"))) {
      return true;
    } else {
      if (newPlanInt < currentPlanInt) {
        return false;
      } else {
        return true;
      }
    }
  } else {
    if (newPlanInt < currentPlanInt) {
      return false;
    } else {
      return true;
    }
  }
};

export const isRestrictBelowPlan = (organization, minimumPlan) => {
  const currentPlanInt = parseInt(organization.trivvyPlanType.replace("0", ""));
  const newPlanInt = parseInt(minimumPlan.replace("0", ""));
  if (newPlanInt < currentPlanInt) {
    return true;
  } else {
    return false;
  }
};

export const getTrivvyRating = (item) => {
  if (item.averageRating > 0) {
    return parseFloat(item.averageRating).toFixed(1);
  } else {
    return "No rating";
  }
};

export const showAsAnonymous = (currentUser, doc) => {
  console.log(currentUser._id, doc);
  if (doc && doc.isAnonymous) {
    if (currentUser && doc.userId == currentUser._id) {
      return false;
    } else {
      return true;
    }
  } else {
    return false;
  }
};

export const getCorrectQuestionsCount = (totalQuestions, percent) => {
  const correctNumber = totalQuestions * (percent / 100);

  return Math.ceil(correctNumber);
};

export const showYou = (currentUser, doc) => {
  if (doc.isAnonymous) {
    if (doc.userId == currentUser._id) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }

  // return false;
};

export const ASSIST_OPTIONS_MAP = {
  MORE_CLEAR: "Make it more clear",
  MORE_ENGAGING: "Make it more engaging",
  MORE_SPECIFIC: "Make it more specific",
  MORE_DIFFICULT: "Make it more difficult",
  LESS_DIFFICULT: "Make it less difficult",
};

export const minPlanLimitCheck = (currentPlan, minPlan) => {
  if (currentPlan && minPlan) {
    const currentPlanInt = parseInt(currentPlan.replace("0", ""));
    const newPlanInt = parseInt(minPlan.replace("0", ""));
    if (newPlanInt <= currentPlanInt) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const TEMPLATE_TYPE_MAP = {
  HOLIDAY: "Calendar Celebrations",
  CAREER_ADVANCEMENT: "Career advancement",
  WORKPLACE_RELATIONSHIP: "Workplace relationships",
  BENEFITS: "Benefits",
  CUSTOMER_SATISFACTION: "Customer satisfaction",
};

export const TEMPLATE_TYPE_CSS_CLASS = {
  HOLIDAY: "holiday-block",
  CAREER_ADVANCEMENT: "advancement-block",
  WORKPLACE_RELATIONSHIP: "relationships-block",
  BENEFITS: "benefit-block",
  CUSTOMER_SATISFACTION: "satisfaction-block",
};

export const TEMPLATE_TYPE_COLORS = {
  HOLIDAY: {
    color: "#800080",
    "background-color": "rgb(128 0 128 / 20%)",
  },
  CAREER_ADVANCEMENT: {
    color: "#027d80",
    "background-color": "rgb(2 125 128 / 20%)",
  },
  WORKPLACE_RELATIONSHIP: {
    color: "#ff4500",
    "background-color": "rgb(255 69 0 / 20%)",
  },
  BENEFITS: {
    color: "#0d7ca8",
    "background-color": "rgb(18 153 207 / 20%)",
  },
};

export const isTrivvyGeneratedFromCustomTemplates = (currentTrivia) => {
  if (!currentTrivia) {
    return false;
  }

  if (
    currentTrivia.templateType === "CAREER_ADVANCEMENT" ||
    currentTrivia.templateType === "WORKPLACE_RELATIONSHIP" ||
    currentTrivia.templateType === "BENEFITS" ||
    currentTrivia.templateType === "CUSTOMER_SATISFACTION"
  ) {
    return true;
  } else {
    return false;
  }
};

export const SENTIMENTS_COLOR_MAP = {
  POSITIVE: "rgb(50 238 50 / 7%)",
  NEGATIVE: "rgb(212 91 234 / 6%)",
  NEUTRAL: "rgb(97 96 95 / 6%)",
  MIXED: "rgb(255 251 33 / 13%)",
};
export const SENTIMENTS_COLOR_MAP2 = {
  POSITIVE: "rgb(9 208 9 / 20%)",
  NEGATIVE: "rgbrgb(208 9 9 / 20%)",
  NEUTRAL: "rgb(162 168 161 / 20%)",
  MIXED: "rgb(162 168 161 / 20%)",
};
export const SENTIMENTS_TYPO_MAP2 = {
  POSITIVE: "Positive",
  NEGATIVE: "Negative",
  NEUTRAL: "Neutral",
  MIXED: "Mixed",
};
export const SENTIMENTS_TYPO_MAP = {
  POSITIVE: "Positive",
  NEGATIVE: "Negative",
  NEUTRAL: "Neutral",
  MIXED: "Mixed",
};

export const sentimentPercent = (value) => {
  return Math.round((value / 1) * 100);
};

export const CREATE_TRIVVY_MODAL_IMAGES = {
  CUSTOM: "https://dev-oo-app-api.s3.us-east-2.amazonaws.com/custom-trivvy.png",
  AI:
    // "https://dev-oo-app-api.s3.us-east-2.amazonaws.com/work-with-ai-trivvy.png"
    "https://dev-oo-app-api.s3.us-east-2.amazonaws.com/work-with-ai+(1).png",
  TEMPLATES:
    "https://dev-oo-app-api.s3.us-east-2.amazonaws.com/templates-trivvy.png",
};

export const isImageUrl = (data) => {
  if (
    data.media_type &&
    (data.media_type.indexOf("image") > -1 ||
      data.media_type.indexOf("gif") > -1)
  ) {
    return true;
  } else {
    return /\.(gif|jpeg|tiff?|png|webp|bmp|jpg)$/i.test(data.media_url);
  }
};

export const renderCommentsCountTextFormat = (count) => {
  if (!count) {
    return 0;
  }
  if (count >= 100) {
    return "100+";
  } else {
    return count;
  }
};
// export const formatDuration = (value) => {
//   const duration = moment.duration(value, "seconds");

//   const years = duration && duration.years && duration.years();
//   const months = duration && duration.months && duration.months();
//   const days = duration && duration.days && duration.days();
//   const hours = duration && duration.hours && duration.hours();
//   const minutes = duration && duration.minutes && duration.minutes();
//   const seconds = duration && duration.seconds && duration.seconds();

//   const parts = [];
//   if (years) parts.push(`${years} yr`);
//   if (months) parts.push(`${months} mo`);
//   if (days) parts.push(`${days} day`);
//   if (hours) parts.push(`${hours} hr`);
//   if (minutes) parts.push(`${minutes} min`);
//   if (seconds || parts.length === 0) parts.push(`${seconds} sec`);

//   return parts.join(" ");
// };

export const formatDuration = (valueInSeconds) => {
  const d = moment.duration(valueInSeconds, "seconds");

  const y = d.years();
  const mo = d.months();
  const d_ = d.days();
  const h = d.hours();
  const m = d.minutes();
  const s = d.seconds();

  if (y > 0) return `${y} yr${y > 1 ? "s" : ""}${mo > 0 ? ` ${mo} mo` : ""}`;
  if (mo > 0) return `${mo} mo${mo > 1 ? "s" : ""}${d_ > 0 ? ` ${d_} day${d_ > 1 ? "s" : ""}` : ""}`;
  if (d_ > 0) return `${d_} day${d_ > 1 ? "s" : ""}${h > 0 ? ` ${h} hr${h > 1 ? "s" : ""}` : ""}`;
  if (h > 0) return `${h} hr${h > 1 ? "s" : ""}${m > 0 ? ` ${m} min` : ""}`;
  if (m > 0) return `${m} min${s > 0 ? ` ${s} sec` : ""}`;
  return `${s} sec`;
};

export const getFileTypeFromUrl = (url) => {
  if (url) {
    if (url.indexOf("pdf") > 0) {
      return "Pdf";
    } else if (url.indexOf("doc") > 0 || url.indexOf("docx") > 0) {
      return "Word";
    } else if (url.indexOf("txt") > 0) {
      return "Text";
    } else {
      return "File";
    }
  } else {
    return "File";
  }
};

export const isPublishedDateGreaterThanGivenDate = (date, survey) => {
  if (!date) {
    return true;
  }
  if (survey.unpublishedDate && survey && survey.publishedDate && date) {
    if (moment(date).isSameOrBefore(moment(survey.publishedDate))) {
      return true;
    }
  }

  return false;
};

export const isAnswerChanged = (question) => {
  const getOptionTextProper = (text) => {
    const optionsRegex = /^[A-Da-d]\s*[-).]\s*(.+)$/;

    function extractOptionText(optionString) {
      const match = optionString.match(optionsRegex);
      if (match) {
        // Extracted option text is in the first capturing group (index 1)
        return match[1].trim();
      } else {
        // Return null or handle the case when there is no match
        return optionString;
      }
    }
    return extractOptionText(text);
  };
  if (question && question.isUserEdited && question.isUserEdited.prev) {
    const answerEdited = question.isUserEdited.prev.filter(
      (x) => x.key == "correct_options"
    );

    if (answerEdited.length >= 0) {
      const originalObject = question.originalObject;
      if (originalObject && originalObject.answer && originalObject.options) {
        let answerString = "";
        if (
          ["A", "B", "C", "D", "a", "b", "c", "d"].includes(
            originalObject.answer.trim()
          )
        ) {
          if (originalObject.answer.toLowerCase() === "a") {
            answerString = originalObject.options[0];
          } else if (originalObject.answer.toLowerCase() === "b") {
            answerString = originalObject.options[1];
          } else if (originalObject.answer.toLowerCase() === "c") {
            answerString = originalObject.options[2];
          } else if (originalObject.answer.toLowerCase() === "d") {
            answerString = originalObject.options[3];
          }
        } else {
          answerString = originalObject.answer;
        }

        if (
          question.correct_options &&
          question.correct_options[0] &&
          question.correct_options[0].text
        ) {
          if (
            contvertHTMLToPlain(question.correct_options[0].text) !=
            getOptionTextProper(answerString)
          ) {
            return true;
          }
        }
      }
    }
  }

  return false;
};

export const getSourceStringfromResponse = (resObj) => {
  if (
    resObj &&
    resObj.question &&
    !resObj.question.isSourceRemoved &&
    resObj.question.question_type === "MCQ" &&
    resObj.question.correct_options &&
    resObj.question.correct_options[0]
  ) {
    return resObj.question.correct_options[0].source || null;
  } else {
    return null;
  }
};
export const getSourceStringfromQuestion = (question) => {
  if (
    question &&
    question.question_type === "MCQ" &&
    question.correct_options &&
    question.correct_options[0]
  ) {
    return question.correct_options[0].source || null;
  } else {
    return null;
  }
};

export const applyCustomFontStyles = (data) => {
  if (data && typeof data == "object") {
    const stylesObj = {};
    if (data.fontWeight) {
      stylesObj.fontWeight = data.fontWeight;
    }

    if (data.fontStyle) {
      stylesObj.fontStyle = data.fontStyle;
    }

    if (data.fontFamilyName) {
      stylesObj.fontFamily = data.fontFamilyName;
    }
    return stylesObj;
  } else {
    return {};
  }
};

export const TRIVVY_LANGUAGES = [
  { label: "English", value: "en" },
  { label: "Spanish (Mexican)", value: "es-MX" },
  { label: "Spanish (European)", value: "es-ES" },
  { label: "French (France)", value: "fr-FR" },
  { label: "French (Canadian)", value: "fr-CA" },
  { label: "German", value: "de" },
  { label: "Chinese (Simplified)", value: "zh-CN" },
  { label: "Chinese (Traditional)", value: "zh-TW" },
  { label: "Japanese", value: "ja" },
  { label: "Korean", value: "ko" },
  { label: "Portuguese (Brazilian)", value: "pt-BR" },
  { label: "Portuguese (European)", value: "pt-PT" },
  { label: "Italian", value: "it" },
  { label: "Russian", value: "ru" },
  { label: "Dutch", value: "nl" },
  { label: "Arabic", value: "ar" },
  { label: "Hindi", value: "hi" },
  { label: "Bengali", value: "bn" },
  { label: "Punjabi", value: "pa" },
  { label: "Turkish", value: "tr" },
  { label: "Vietnamese", value: "vi" },
  { label: "Persian (Farsi)", value: "fa" },
  { label: "Polish", value: "pl" },
  { label: "Ukrainian", value: "uk" },
];

export const TRIVVY_LANG_CODES_MAP = {
  en: "English",
  "es-MX": "Spanish (Mexican)",
  "es-ES": "Spanish (European)",
  "fr-FR": "French (France)",
  "fr-CA": "French (Canadian)",
  de: "German",
  "zh-CN": "Chinese (Simplified)",
  "zh-TW": "Chinese (Traditional)",
  ja: "Japanese",
  ko: "Korean",
  "pt-BR": "Portuguese (Brazilian)",
  "pt-PT": "Portuguese (European)",
  it: "Italian",
  ru: "Russian",
  nl: "Dutch",
  ar: "Arabic",
  hi: "Hindi",
  bn: "Bengali",
  pa: "Punjabi",
  tr: "Turkish",
  vi: "Vietnamese",
  fa: "Persian (Farsi)",
  pl: "Polish",
  uk: "Ukrainian",
};

export const DIFFICULTY_LEVELS = [
  {
    label: "Easy",
    value: 1,
  },
  {
    label: "Medium",
    value: 2,
  },
  {
    label: "Hard",
    value: 3,
  },
];

export const getDifficultyLevels = (value) => {
  const item = DIFFICULTY_LEVELS.find((x) => x.value === value);

  if (item) {
    return item.label;
  } else {
    return "Easy";
  }
};

export const BUILT_WITH_AI_PROMPTS = [
  ,


]
export const BUILT_WITH_AI_PROMPTS_STANDARD = [
  {
    title:"Employee Exit Survey",
    description:"Create an exit interview survey to assess departing employees' views on company culture, work meaning, team/supervisor experience, and reasons for leaving. Include questions on their role and department."
  },
  {
    title:"Event Feedback",
    description:"Develop a post-event survey to gather attendee feedback on the event’s organization, length, moderator/speaker quality, usefulness, and likelihood of attending future webinars."
  },
  {
    title:"360 Employee Feedback Survey",
    description:"Design a 360 feedback survey with scale questions on benefits, shift schedule, teamwork, communication, management, and likelihood to stay with the organization"
  },
  {
    "title": "Biggest Work Hurdle",
    "description": "Generate a survey that identifies the most significant obstacles or challenges employees face in completing their tasks. Focus on uncovering bottlenecks in workflows, process inefficiencies, or issues with communication and resource availability."
  },
  {
    "title": "Process Improvement Ideas",
    "description": "Create a survey that asks employees to identify work processes or procedures they believe could be simplified or improved. Emphasize areas where operational efficiency could be increased, and where employees experience the most frustration or delays."
  },
  {
    "title": "Training & Skill Gaps",
    "description": "Design a survey to explore areas where employees feel they need additional training, support, or resources to perform their jobs effectively. Focus on uncovering gaps in skill development, onboarding processes, or access to learning materials."
  },
  {
    "title": "Most Helpful Coworker",
    "description": "Create a survey that encourages employees to name a coworker who has been particularly helpful to them, and to explain how that person’s actions or behaviors improved their work experience. Use this to uncover patterns of collaboration and peer support."
  },
  {
    "title": "Tool & Technology Needs",
    "description": "Generate a survey that asks employees if they feel they have the necessary tools, software, and technology to perform their roles effectively. Focus on areas where additional resources or upgrades may be required to optimize productivity."
  },
  {
    "title": "Communication & Feedback",
    "description": "Develop a survey to assess how employees prefer to receive important work updates and feedback. Investigate the effectiveness of current communication channels and whether employees feel well-informed and supported by leadership."
  },
  {
    "title": "Support from Leadership",
    "description": "Create a survey to understand how supported employees feel by their direct managers and leadership. Focus on uncovering areas where leadership could provide better guidance, advocacy, or alignment in achieving work goals."
  },
  {
    "title": "Job Satisfaction Improvement",
    "description": "Generate a survey to ask employees what specific changes or resources would make their jobs easier, more satisfying, or less stressful. Focus on identifying actions that could reduce friction or increase employee engagement."
  },
  {
    "title": "Career Growth",
    "description": "Design a survey to explore how employees perceive their opportunities for career growth within the company. Ask about the support, resources, or programs they believe would help them advance professionally."
  },
  {
    "title": "Recognition",
    "description": "Create a survey that asks employees how the organization could improve its recognition and reward systems. Focus on what types of acknowledgment or rewards employees find most meaningful and motivating."
  },
  {
    "title": "Work Efficiency Check-In",
    "description": "Generate a survey that asks employees what changes, resources, or tools would help them complete their tasks more efficiently. Encourage responses that focus on removing barriers, improving processes, or enhancing support."
  },
  {
    "title": "Communication Effectiveness",
    "description": "Design a survey to assess how effectively and timely employees receive important communication from leadership. Investigate whether employees feel informed, aligned, and clear about company goals and changes."
  },
  {
    "title": "Workload & Productivity",
    "description": "Create a survey to determine if employees feel their workload is manageable and how external or internal factors may be affecting their productivity. Focus on identifying stressors, workload distribution, and support needs."
  },
  {
    "title": "Team Collaboration Needs",
    "description": "Generate a survey to assess how employees perceive collaboration within their teams. Ask about the effectiveness of team communication, decision-making, and how well responsibilities and tasks are shared."
  },
  {
    "title": "Work-life Balance",
    "description": "Develop a survey to explore what changes could help employees achieve a better work-life balance. Focus on factors like flexible work arrangements, workload expectations, and policies that support personal life outside of work."
  },
  {
    "title":"Customer Satisfaction (CSAT)",
    "description":"Create a customer satisfaction survey to assess overall satisfaction with a recent product or service experience, including ease of use, quality, value, and likelihood of continued use."

  },
  {
    "title":"Net Promoter Score (NPS)",
    "description":"Develop a Net Promoter Score survey to measure customer loyalty and advocacy, including likelihood to recommend, reasons behind their rating, and areas for improvement."

  },
  {
    "title":"Customer Service Feedback",
    "description":"Create a customer service feedback survey to evaluate a support interaction, including responsiveness, professionalism, resolution quality, and overall satisfaction."

  },
  {
    "title":"Customer Onboarding Experience",
    "description":"Develop an onboarding experience survey to gather feedback from new customers on clarity of the process, helpfulness of training/resources, time to value, and overall onboarding satisfaction."

  },
  {
    "title":"Win/Loss Analysis (Sales)",
    "description":"Create a win/loss analysis survey to understand why prospects chose to purchase or not purchase, including perceptions of our product or service, pricing, sales process, competitors, and decision factors."

  }


]

export const  CAPITAL_ALPHABETS = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));


export function  splitStringIntoChunks(str, n) {
  if (n <= 0) throw new Error("n must be greater than 0");

  if(!str || str.length ===0) return [];

  const chunkSize = Math.ceil(str.length / n); // Determine chunk size
  let result = [];

  for (let i = 0; i < str.length; i += chunkSize) {
      result.push(str.slice(i, i + chunkSize));
  }

  return result;
}
